import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import Button from 'src/components/ui/button';

import paymentStore from 'src/stores/payment-store';

import useSluggedNavigate from 'src/hooks/use-slugged-navigate';
import { AppRoute, GoogleAnalyticsButton, GoogleAnalyticsPage, LOCALES } from 'src/constants';
import { getGoogleAnalyticsEvent } from 'src/utils';
import type { PaymentButtonsProps } from './payment-buttons.props';

import './payment-buttons.scss';

const PaymentButtons = observer(({ onPaymentButtonClick }: PaymentButtonsProps) => {
  const navigate = useSluggedNavigate();
  const handleBackButtonClick = () => navigate(AppRoute.CHECKOUT_PAGE_ROUTE);

  return (
    <div
      className={classNames('payment-buttons', !onPaymentButtonClick && 'payment-buttons_single')}
    >
      {onPaymentButtonClick && (
        <Button
          className="payment-buttons__item  payment-buttons__item_primary"
          analyticsEvent={getGoogleAnalyticsEvent(
            GoogleAnalyticsPage.PAYMENT,
            GoogleAnalyticsButton.MAKE_PAYMENT
          )}
          isDisabled={paymentStore.isPaymentLoading}
          label={LOCALES.MAKE_PAYMENT}
          size="oversize"
          theme="filled"
          onClick={onPaymentButtonClick}
        />
      )}
      <Button
        className="payment-buttons__item"
        analyticsEvent={getGoogleAnalyticsEvent(
          GoogleAnalyticsPage.PAYMENT,
          GoogleAnalyticsButton.BACK
        )}
        isDisabled={paymentStore.isPaymentLoading}
        label={LOCALES.BACK}
        size="oversize"
        theme="outlined"
        onClick={handleBackButtonClick}
      />
    </div>
  );
});

export default PaymentButtons;
